import { render, staticRenderFns } from "./HomeServicesPage.vue?vue&type=template&id=10423cc6&"
import script from "./HomeServicesPage.vue?vue&type=script&lang=ts&"
export * from "./HomeServicesPage.vue?vue&type=script&lang=ts&"
import style0 from "./HomeServicesPage.vue?vue&type=style&index=0&id=10423cc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports